import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import z from 'zod'

import { JobSearchPreferenceInputObjectSchema } from '@gql/zod'

import { TJobSearchPreferencesForm } from '@/forms/types'

export const JobSearchPreferencesFormSchema = z.object({
  jobSearchPreferences: JobSearchPreferenceInputObjectSchema().optional(),
})

interface IUseJobSearchPreferencesFormParams {
  preloadedValues?: Partial<TJobSearchPreferencesForm>
}

export const useJobSearchPreferencesForm = ({
  preloadedValues,
}: IUseJobSearchPreferencesFormParams = {}) => {
  const defaultValues = {
    jobSearchPreferences: undefined,
  }

  const form = useForm<TJobSearchPreferencesForm>({
    defaultValues,
    resolver: zodResolver(JobSearchPreferencesFormSchema),
    values: { ...defaultValues, ...preloadedValues },
  })

  const resetForm = () => form.reset(defaultValues)

  return {
    form,
    resetForm,
  }
}
